<template>
  <div class="mobile-i18n-page full_container">
    <div class="full_box">
      <custom-tabs
        :activeTab.sync="active"
        :tabs="tabs"
        :hasBack="false"
        :lineStyle="2"
      >
      </custom-tabs>

      <!-- <van-search
        readonly
        shape="round"
        placeholder="搜索料号、名称"
        background="#ffffff00"
        class="search_box"
        @click="$router.push('/search')"
      /> -->
      <div class="search_box">
        <!-- 搜索料号、名称 -->
        <!-- 搜索 -->
        <SearchBox
          :placeholder="$t('mobileClue.searchPartOrName')"
          :button-text="$t('mobileClue.search')"
          input-bg-color="rgba(255, 255, 255, 0.9)"
          button-bg-color="#4286F5"
          button-text-color="#ffffff"
          shape="round"
          @search="onProductSearch"
        />
      </div>

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="gridLayout">
          <van-grid :gutter="10" v-if="navList && navList.length > 0">
            <van-grid-item
              @click="onJump(item)"
              v-for="(item, index) in navList"
              :key="index"
              :icon="item.imgUrl"
              :text="item.text"
              class="clickable"
            />
          </van-grid>
        </div>
        <div v-if="list && list.length > 0">
          <!-- 我们是有底线的 -->
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('mobileClue.listEnd')"
            @load="onLoad"
          >
            <div class="goods-list" v-if="list && list.length > 0">
              <GoodsItem
                v-for="(item, index) in list"
                :key="index"
                :item="item"
              ></GoodsItem>
            </div>
            <div v-else>
              <!-- 暂无数据 -->
              <van-empty :description="$t('mobileClue.noData')" />
            </div>
          </van-list>
        </div>
        <!-- 暂无数据 -->
        <van-empty v-else :description="$t('mobileClue.noData')" />
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
/**
 * 名称：供求
 * 日期：2025-04-22 09:08:09
 * 作者：bd
 */
import CustomTabs from "@/components/CustomTabs.vue";
import SearchBox from "@/components/SearchBox.vue";
import { getNavList } from "@/api/index";
import { listGoods } from "@/api/goods";
import GoodsItem from "@/components/GoodsItem.vue";
import { mapState } from "vuex";
export default {
  components: { CustomTabs, GoodsItem, SearchBox },
  props: {},
  data() {
    return {
      active: 0,
      list: [],
      serachShow: false, //搜索查询状态刷新状态
      checkMore: true,
      refreshing: false, //刷新状态默认值
      loading: false,
      finished: false,
      isLoading: false,
      params: {
        pageSize: 10,
        pageNum: 1,
        status: null,
        type: 1, //类型1货源2求购
      },
      navList: [],
      navParams: {
        which: 2,
        position: "CLUE_SOURCE",
        status: 0,
      },
      isFixed: false,
    };
  },
  watch: {
    active(val) {
      this.supeActive();
      // this.onLoad();
      this.queryNav();
      this.params.pageNum = 1;
      this.serachShow = true;
      this.queryList();
    },
  },
  computed: {
    tabs() {
      return [
        // 货源
        { title: this.$t("mobileClue.supply"), name: 0 },
        // 求购
        { title: this.$t("mobileClue.wantToBuy"), name: 1 },
      ];
    },
    ...mapState({
      userInfo: (state) => state.user.userDetails,
    }),
    searchBoxClass() {
      return {
        fixed: this.isFixed,
      };
    },
  },
  mounted() {
    // 找到滚动容器（这里假设是body或.common_container容器）
    this.scrollContainer = document.querySelector(".full_container");
    // 使用Vue的事件监听方式
    this.scrollContainer.addEventListener("scroll", this.handleScroll);
    // 初始化搜索框位置
    this.updateSearchBoxPosition();
  },
  beforeDestroy() {
    // 移除滚动事件监听
    if (this.scrollContainer) {
      console.log("移除滚动事件监听");
      this.scrollContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    // 处理商品搜索（子组件触发的事件）
    onProductSearch(value) {
      console.log("父组件接收商品搜索值：", value);
      // 这里写商品搜索的业务逻辑
      // 例如：调用接口 this.$api.searchProduct(value)
    },
    // 处理滚动事件
    handleScroll() {
      this.updateSearchBoxPosition();
    },

    // 更新搜索框位置
    updateSearchBoxPosition() {
      const scrollTop = this.scrollContainer.scrollTop;
      const isFixed = scrollTop > 75; // 当滚动超过75px时固定搜索框
      // 更新固定状态
      this.isFixed = isFixed;
      // 对于Vue 2，通过动态类名控制样式
    },
    queryRoute() {
      let query = this.$route.query;
      if (query) {
        this.active = query.active ? JSON.parse(query.active) : 0;
        this.supeActive();
      }
    },
    queryNav() {
      getNavList(this.navParams).then((res) => {
        if (res.code == 200 && res.data) {
          this.navList = res.data ?? [];
        }
      });
    },
    supeActive() {
      if (this.active == 0) {
        this.params.type = 1;
        this.navParams.position = "CLUE_SOURCE";
      }
      if (this.active == 1) {
        this.params.type = 2;
        this.navParams.position = "CLUE_BUY";
      }
    },
    //页面加载
    onLoad() {
      this.isLoading = false;
      // 模拟更新数据
      if (this.checkMore) {
        this.loading = true;
        // 如果有新数据
        setTimeout(() => {
          this.queryList();
        }, 300);
      } else {
        // 如果没有新数据
        this.finished = true;
      }
    },
    onRefresh() {
      this.params.pageNum = 1;
      this.serachShow = true;
      setTimeout(() => {
        this.queryList();
        this.queryNav();
        this.isLoading = false;
      }, 1000);
      // setTimeout(() => {
      //   this.onLoad();
      //   this.queryNav();
      //   this.isLoading = false;
      // }, 1000);
    },
    queryList() {
      listGoods(this.params).then((res) => {
        this.loading = false;
        this.finished = true;
        if (res.code == 200 && res.data) {
          this.list = res.data.records ?? [];
          let list = res.data.records;
          if (list.length > 0) {
            this.list = list;
            return;
            if (this.serachShow == true) {
              this.list = list;
            } else {
              this.list = this.list.concat(list);
            }
            this.loading = false; //在每次请求完毕后设置false表示加载结束
            this.isLoading = false; //刷新

            let currpage = this.params.pageNum; //当前页面
            let rows = this.params.pageSize; //当前条数
            var pageSize = parseInt(rows); //每页数量
            var totalCount = parseInt(res.data.total); //总数量
            var pageCount = Math.floor((totalCount + pageSize - 1) / pageSize); //得到的总页码
            if (pageCount > currpage) {
              currpage++;
              this.params.pageNum = currpage;
              this.checkMore = true;
              this.finished = false; //false还有数据
            } else {
              this.checkMore = false;
              this.finished = true; //true没有数据-表示加载完了
            }
          } else {
            this.finished = true;
            this.isLoading = false;
            this.loading = false;
            this.list = [];
          }
        }
      });
    },
    isLogin() {
      return this.$store.getters.token;
    },
    onJump(item) {
      if (item.path) {
        this.$router.push(item.path);
      } else {
        this.$router.push("/myxg/myDetails?id=" + item.id + "&source=order");
      }
    },
  },
  created() {
    this.queryRoute();
    this.onLoad();
    this.queryNav();
  },
};
</script>
<style lang="less" scoped>
.full_container {
  background: url(@/img/clue/clue-bg.png) no-repeat center center fixed;
  background-size: cover;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: -1;
  // position: relative;
  .full_box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow-y: hidden;

    .search_box {
      margin-top: 8px;
      padding: 8px;
    }
    .van-pull-refresh {
      flex: 1;
      overflow-y: auto;
    }

    .goods-list {
      padding: 8px 16px 12px;
    }
  }
  // 搜索框样式定制
  // .van-search {
  //   position: absolute;
  //   top: @common-th;
  //   z-index: 99;
  // }
  // .van-search.fixed {
  //   position: fixed; /* 滚动时切换为固定定位 */
  //   top: 0; /* 固定在顶部 */
  //   max-width: 700px;
  // }

  // .tabBoxs {
  //   margin-top: 120px;
  //   /deep/.van-tabs__content {
  //     padding: 12px;
  //   }
  // }
  //   .van-search__content {
  //   background: rgba(255, 255, 255, 0.901) !important;
  // }
}
</style>
